var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"is-vertical h-100"},[_c('el-container',{staticClass:"relative h-100"},[_c('filters-component',{on:{"submitFilters":_vm.searchHandler}}),_vm._v(" "),_c('library-items',{attrs:{"searchEnabled":true,"items":_vm.$store.state.libraryItems},on:{"delete-item":_vm.deleteTour}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440a2fbc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Library.vue
// module id = null
// module chunks = 